<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-text-field
        :readonly="readonly"
        v-model="username"
        :label="$t('Settings.username')"
        required
        @change="usernameSend"
      ></v-text-field>
    </v-col>

    <v-col cols="12" sm="6">
      <v-form v-model="valid">
        <v-text-field
          :readonly="readonly"
          :rules="[rules.validateEmail]"
          v-model="mail"
          :label="$t('Settings.mail')"
          @change="mailSend"
          required
        ></v-text-field>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  data() {
    return {
      username: "",
      mail: "",
      userId: "",
      valid: false,
      rules: {
        validateEmail: value => {
          var re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
          return (
            re.test(String(value).toLowerCase()) ||
            this.$t("Login.RegisterComponent.rules.mail")
          );
        }
      }
    };
  },
  props: {
    readonly: Boolean
  },
  methods: {
    mailSend: function() {
      this.$emit("mail", this.mail);
    },
    usernameSend: function() {
      this.$emit("username", this.username);
    }
  },
  beforeMount: function() {
    axios
      .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
        headers: { Authorization: tokenStore.getToken() }
      })
      .then(res => {
        this.mail = res.data.user.mail;
        this.$emit("mail", this.mail);
        this.username = res.data.user.username;
        this.$emit("username", this.username);
        this.userId = res.data.user.id;
        this.$emit("userid", this.userId);
        this.$emit("lang", res.data.user.lang);
      })
      .catch(err => {
        console.log(err);
        tokenStore.refreshToken();
      });
  }
};
</script>